/**
 * Help & support (Phase 1, G12): one support address (owner decision: support@quixomarketing.com, the M365 mailbox that
 * also sends customer email), WhatsApp, and answers to the three questions audit buyers ask: where is my report, how do
 * re-runs work, how do refunds work. EN/AR from the shell catalog. No form: email and WhatsApp are the support routes.
 */
import { Link } from 'react-router';
import { Card, CardHead, PageHeader, Text } from '@qm/ui';
import { useApp } from '../../../lib/app-context';
import { Icon } from '../../../shell/Icon';
import { SupportCases } from './SupportCases';
import '../audit/audit.css';

export const SUPPORT_EMAIL = 'support@quixomarketing.com';
/** Company WhatsApp number as published on quixomarketing.com (contact page and footer). */
export const SUPPORT_WHATSAPP = 'https://wa.me/971501022877';

const FAQ = ['report', 'reportLink', 'rerun', 'refund', 'team', 'arabic'] as const;

export function HelpPage() {
  const { t } = useApp();
  const subject = encodeURIComponent(t('shell.p1.help.mailSubject'));
  return (
    <section className="qm-page qm-audit" aria-labelledby="page-title">
      <PageHeader title={t('shell.p1.help.title')} intro={t('shell.p1.help.intro')} />
      <div className="qm-audit__grid">
        <Card aria-labelledby="help-email">
          <CardHead id="help-email" title={t('shell.p1.help.emailTitle')} icon={<Icon name="headset" size={16} />} />
          <Text>{t('shell.p1.help.emailBody')}</Text>
          <a className="qm-button" data-variant="ink" href={`mailto:${SUPPORT_EMAIL}?subject=${subject}`}><bdi>{SUPPORT_EMAIL}</bdi></a>
        </Card>
        <Card aria-labelledby="help-wa">
          <CardHead id="help-wa" title={t('shell.p1.help.waTitle')} icon={<Icon name="inbox" size={16} />} />
          <Text>{t('shell.p1.help.waBody')}</Text>
          <a className="qm-button" href={SUPPORT_WHATSAPP} target="_blank" rel="noopener noreferrer">{t('shell.p1.help.waCta')}</a>
        </Card>
      </div>
      <Card aria-labelledby="help-faq">
        <CardHead id="help-faq" title={t('shell.p1.help.faqTitle')} />
        <div className="qm-faq">
          {FAQ.map((q) => (
            <details key={q}>
              <summary>{t(`shell.p1.help.faq.${q}.q`)}</summary>
              <p>{t(`shell.p1.help.faq.${q}.a`, { email: SUPPORT_EMAIL })}</p>
            </details>
          ))}
        </div>
      </Card>
      <SupportCases />
      <Text tone="muted">{t('shell.p1.help.more')} <Link to="/audit">{t('shell.screens.audit.title')}</Link> · <Link to="/settings/security">{t('shell.module.link.security')}</Link></Text>
    </section>
  );
}
